import { AiFillCaretLeft } from "react-icons/ai"; 
import { BiTrash } from "react-icons/bi"; 
import { BiSave } from "react-icons/bi"; 
import CxIcon from '../../cx/CxIcon';
import React from 'react';
import GxForm from '../../gx/GxForm';
import { useTranslation } from '../../hx/useTranslation';
import { useNav } from '../../hx/useNav';
import CxInput from '../../cx/CxInput';
import CxNumber from '../../cx/CxNumber';
import CxAccordion from '../../cx/CxAccordion';
import CxTime from '../../cx/CxTime';
import CxState from '../../cx/CxState';
import CxDialog from '../../cx/CxDialog';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import { StoreSettCalendarCol } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';
import CxSnackbar from '../../cx/CxSnackbar';
import * as FxFetch from '../../fx/FxFetch';
import CxIconButtonNew from '../../cx/CxIconButtonNew';
import CxBackdrop from '../../cx/CxBackdrop';


const MxSettCalendarColForm = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navBack }] = useNav();

  const r_snack_record_used = React.useRef(null);
  const r_snack_save = React.useRef(null);
  const r_snack_required = React.useRef(null);

  let r_form = React.useRef(null);
  
  const [dlgDelete, setDlgDelete] = React.useState(false);
  const [backdrop, setBackdrop] = React.useState(false);
  
  const rf_txTypeCalendarCol = React.useRef(null);
  const rf_nuSequence = React.useRef(null);

  const rf_boOnlineApptActive = React.useRef(null);
  const rf_nuOnlineApptIntervalMins = React.useRef(null);
  const rf_txOnlineApptTime1From = React.useRef(null);
  const rf_txOnlineApptTime1To = React.useRef(null);
  const rf_txOnlineApptTime2From = React.useRef(null);
  const rf_txOnlineApptTime2To = React.useRef(null);

  const rf_day_mo = React.useRef(null);
  const rf_day_tu = React.useRef(null);
  const rf_day_we = React.useRef(null);
  const rf_day_th = React.useRef(null);
  const rf_day_fr = React.useRef(null);
  const rf_day_sa = React.useRef(null);
  const rf_day_su = React.useRef(null);
  
  const [storeSettCalendarCol, setStoreSettCalendarCol] = useSessionStorage('StoreSettCalendarCol', StoreSettCalendarCol);

  const isGeneral = () => storeSettCalendarCol.itCalendarCol!=='000001.SRV';

  React.useEffect(() => {
    formLoadCustom();
    // eslint-disable-next-line
  }, []);

  const formLoadCustom = async () => {
    let record = {};
    record['idValue'] = storeSettCalendarCol.itCalendarCol;
    Promise.all([FxFetch.doJsonX('sett/cal_col/r', record)]).then((result) => {
      let rv = result[0][0];
      if (rv) {
        //FxLog.infox('MxSettCalendarColForm.formLoad', '...result[0]:', result[0]);
        rf_boOnlineApptActive.current.setVal(rv.boOnlineApptActive);
        rf_txTypeCalendarCol.current.setVal(rv.txTypeCalendarCol);
        rf_nuSequence.current.setVal(rv.nuSequence);
        rf_nuOnlineApptIntervalMins.current.setVal(rv.nuOnlineApptIntervalMins);
        rf_txOnlineApptTime1From.current.setVal(rv.txOnlineApptTime1From||'');
        rf_txOnlineApptTime1To.current.setVal(rv.txOnlineApptTime1To||'');
        rf_txOnlineApptTime2From.current.setVal(rv.txOnlineApptTime2From||'');
        rf_txOnlineApptTime2To.current.setVal(rv.txOnlineApptTime2To||'');

        let txOnlineApptWeekDays = rv.txOnlineApptWeekDays;
        rf_day_mo.current.setValBoolean(txOnlineApptWeekDays.charAt(0) === '1');
        rf_day_tu.current.setValBoolean(txOnlineApptWeekDays.charAt(1) === '1');
        rf_day_we.current.setValBoolean(txOnlineApptWeekDays.charAt(2) === '1');
        rf_day_th.current.setValBoolean(txOnlineApptWeekDays.charAt(3) === '1');
        rf_day_fr.current.setValBoolean(txOnlineApptWeekDays.charAt(4) === '1');
        rf_day_sa.current.setValBoolean(txOnlineApptWeekDays.charAt(5) === '1');
        rf_day_su.current.setValBoolean(txOnlineApptWeekDays.charAt(6) === '1');
      }
    });
  }

  const formDeleteCustom = () => {
    setDlgDelete(true);
  }

  const doDelete = () => {

    //-----------------------------------------------------------------------
    setBackdrop(true);

    let record = {};
    record['idValue'] = storeSettCalendarCol.itCalendarCol;
    Promise.all([FxFetch.doJsonF(`sett/cal_col/d`, null, record)]).then((result) => {
      if (result[0].theValue === 'rv_error') {
        r_snack_record_used.current.setOpen(true);
      } else {
        navBack();
      }
    });
    //-----------------------------------------------------------------------
  }

  const formSaveCustom = async () => {

    if (rf_txTypeCalendarCol.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_txTypeCalendarCol.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }
    if (rf_nuSequence.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_nuSequence.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }

    let filter = {};
    let record = {};
    filter['itCalendarCol'] = storeSettCalendarCol.itCalendarCol;
    record['txTypeCalendarCol'] = rf_txTypeCalendarCol.current.getVal();
    record['nuSequence'] = rf_nuSequence.current.getVal();
    record['boOnlineApptActive'] = rf_boOnlineApptActive.current.getVal();
    record['txOnlineApptTime1From'] = rf_txOnlineApptTime1From.current.getVal();
    record['txOnlineApptTime1To'] = rf_txOnlineApptTime1To.current.getVal();
    record['txOnlineApptTime2From'] = rf_txOnlineApptTime2From.current.getVal();
    record['txOnlineApptTime2To'] = rf_txOnlineApptTime2To.current.getVal();
    record['nuOnlineApptIntervalMins'] = rf_nuOnlineApptIntervalMins.current.getVal();
    
    let txOnlineApptWeekDays = '';
    txOnlineApptWeekDays += rf_day_mo.current.getVal();
    txOnlineApptWeekDays += rf_day_tu.current.getVal();
    txOnlineApptWeekDays += rf_day_we.current.getVal();
    txOnlineApptWeekDays += rf_day_th.current.getVal();
    txOnlineApptWeekDays += rf_day_fr.current.getVal();
    txOnlineApptWeekDays += rf_day_sa.current.getVal();
    txOnlineApptWeekDays += rf_day_su.current.getVal();
    record['txOnlineApptWeekDays'] = txOnlineApptWeekDays;

    Promise.all([FxFetch.doJsonF("sett/cal_col/cu", filter, record)]).then((result) => {
      if (result[0]) {
        if (result[0].theStatus === 'OK') {
          storeSettCalendarCol.itCalendarCol = result[0].theValue;
          Promise.all([setStoreSettCalendarCol(storeSettCalendarCol)]).then((result) => {
            r_snack_save.current.setOpen(true);
          });
        }
      }
    });
  }

  return (
    <div>
      <GxForm
        moduleName={`${trans('field.calendars')}: ${trans('field.column')}`}
        xref={r_form}
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            {isGeneral() && <CxIconButtonNew icon={<BiTrash/>} classType="ibs_iconbutton_toolbar" onClick={formDeleteCustom} tooltip={trans('field.delete')} />}
            <CxIconButtonNew icon={<CxIcon backIcon={<BiSave/>} frontIcon={<AiFillCaretLeft/>} />} classType="ibs_iconbutton_toolbar" onClick={() => formSaveCustom()} tooltip={trans('field.save_and_exit')} />
          </div>
        }
      >
        <CxInput xref={rf_txTypeCalendarCol} label={trans('field.name')} disabled={!isGeneral()} maxLength="30" required />
        <CxNumber xref={rf_nuSequence} label={trans('field.sequence')} required />

        <CxAccordion title={trans('field.online_appointments')} background={"var(--ibs_color_gray_light)"} color={"var(--ibs_color_black)"} >
          <CxState mode='checkbox' xref={rf_boOnlineApptActive} label={trans('field.active_1')} />

          <CxTime xref={rf_txOnlineApptTime1From} label={trans('field.hour_morning_start')} />
          <CxTime xref={rf_txOnlineApptTime1To} label={trans('field.hour_morning_end')} />
          <CxTime xref={rf_txOnlineApptTime2From} label={trans('field.hour_afternoon_start')} />
          <CxTime xref={rf_txOnlineApptTime2To} label={trans('field.hour_afternoon_end')} />

          <CxNumber xref={rf_nuOnlineApptIntervalMins} label={`${trans('field.interval')} - ${trans('field.minutes')}`} decimals={0} />

          <span style={{ width: '100%', display: 'flex', flexDirection: 'row', gap: '10px', flexWrap: "wrap" }}>
            <CxState mode='checkbox' xref={rf_day_mo} label={trans('field.day_mo')} />
            <CxState mode='checkbox' xref={rf_day_tu} label={trans('field.day_tu')} />
            <CxState mode='checkbox' xref={rf_day_we} label={trans('field.day_we')} />
            <CxState mode='checkbox' xref={rf_day_th} label={trans('field.day_th')} />
            <CxState mode='checkbox' xref={rf_day_fr} label={trans('field.day_fr')} />
            <CxState mode='checkbox' xref={rf_day_sa} label={trans('field.day_sa')} />
            <CxState mode='checkbox' xref={rf_day_su} label={trans('field.day_su')} />
          </span>
        </CxAccordion>

      </GxForm>

      <CxDialog title={trans('msg.warning')} open={dlgDelete}
        onCancel={() => setDlgDelete(false)}
        onOk={() => { setDlgDelete(false); doDelete() }}
        height='200px'>
        {trans('msg.ask_delete')}
      </CxDialog>

      <CxBackdrop open={backdrop} />
      <CxSnackbar xref={r_snack_record_used} severity="error" value={trans('msg.record_used')} />
      <CxSnackbar xref={r_snack_save} severity="success" value={trans('msg.saved')} onClose={() => navBack()} />
      <CxSnackbar xref={r_snack_required} severity="error" />

    </div>
  );

}

export default MxSettCalendarColForm;
